/** Automatic GPS following is limited to the property or its immediate vicinity. */
export const PROPERTY_FOLLOW_BUFFER_METERS = 500;
export function isNearProperty(point:[number,number],boundary:unknown,bufferMeters=PROPERTY_FOLLOW_BUFFER_METERS):boolean {
  if(!point.every(Number.isFinite)||Math.abs(point[0])>90||Math.abs(point[1])>180)return false;
  try {
    let geometry:any=typeof boundary==='string'?JSON.parse(boundary):boundary;
    if(geometry?.type==='Feature')geometry=geometry.geometry;
    const geoJson=!!geometry?.type;
    const raw=geometry?.coordinates??geometry;
    const polygons:any[]=geometry?.type==='MultiPolygon'?raw: [Array.isArray(raw?.[0])&&typeof raw[0][0]==='number'?[raw]:raw];
    const radians=Math.PI/180;
    const project=([lat,lng]:[number,number])=>[(lng-point[1])*111195*Math.cos(point[0]*radians),(lat-point[0])*111195];
    const inside=(ring:[number,number][])=>{
      let hit=false;
      for(let i=0,j=ring.length-1;i<ring.length;j=i++){
        const [y,x]=ring[i],[py,px]=ring[j];
        if((y>point[0])!==(py>point[0])&&point[1]<(px-x)*(point[0]-y)/(py-y)+x)hit=!hit;
      }return hit;
    };
    return polygons.some(polygon=>{
      if(!Array.isArray(polygon))return false;
      const rings:[number,number][][]=polygon.map((ring:any)=>Array.isArray(ring)?ring.map((pair:any)=>geoJson?[pair[1],pair[0]]:pair).filter((pair:any)=>Array.isArray(pair)&&pair.length>=2&&pair.every(Number.isFinite)&&Math.abs(pair[0])<=90&&Math.abs(pair[1])<=180):[]);
      if(!rings[0]||rings[0].length<3)return false;
      if(inside(rings[0])&&!rings.slice(1).some(inside))return true;
      return rings.some(ring=>ring.some((vertex,i)=>{
        const a=project(vertex),b=project(ring[(i+1)%ring.length]);
        const dx=b[0]-a[0],dy=b[1]-a[1],length=dx*dx+dy*dy;
        const t=length?Math.max(0,Math.min(1,-(a[0]*dx+a[1]*dy)/length)):0;
        return Math.hypot(a[0]+t*dx,a[1]+t*dy)<=bufferMeters;
      }));
    });
  }catch{return false;}
}
export function propertyBounds(boundary:unknown):[[number,number],[number,number]]|null {
  try{
    let geometry:any=typeof boundary==='string'?JSON.parse(boundary):boundary;
    if(geometry?.type==='Feature')geometry=geometry.geometry;
    const geoJson=!!geometry?.type;
    const points:[number,number][]=[];
    const walk=(value:any)=>{if(!Array.isArray(value))return;if(typeof value[0]==='number'&&typeof value[1]==='number'){const point:[number,number]=geoJson?[value[1],value[0]]:[value[0],value[1]];if(point.every(Number.isFinite)&&Math.abs(point[0])<=90&&Math.abs(point[1])<=180)points.push(point);}else value.forEach(walk);};
    walk(geometry?.coordinates??geometry);
    return points.length>=3?[[Math.min(...points.map(p=>p[0])),Math.min(...points.map(p=>p[1]))],[Math.max(...points.map(p=>p[0])),Math.max(...points.map(p=>p[1]))]]:null;
  }catch{return null;}
}
